@use "ui/styles/colors";
@use "ui/styles/effects";

.tabNavigation {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 1px solid colors.$gray30;
}

.tabButton {
  padding: 12px 16px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  color: colors.$gray60;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    color: colors.$gray90;
  }

  &.active {
    color: colors.$blue;
    border-bottom-color: colors.$blue;
  }
}

.checkboxWrapper {
  margin-top: 16px;
}

.reportingUnitsTab {
  min-height: 300px;
}
